import React, { createContext, useContext } from "react"

const RouteNameContext = createContext<{
  previousRouteNameRef?: React.MutableRefObject<string>,
  routeNameRef?: React.MutableRefObject<string>,
  previousRouteName?: string|null,
  routeName?: string|null
}>({
  previousRouteNameRef: null,
  routeNameRef: null,
  previousRouteName: null,
  routeName: null
})

export const RouteNameProvider = RouteNameContext.Provider
export const useRouteName = () => useContext(RouteNameContext)
